
    __webpack_require__.initializeExposesData = {
  moduleMap: {
  "./Compliance": () => {
return Promise.all(/*  | __federation_expose_Compliance */ [__webpack_require__.e("558"), __webpack_require__.e("161"), __webpack_require__.e("343"), __webpack_require__.e("490")]).then(() => (() => (__webpack_require__(537))));
},
},
  shareScope: "default",
};
__webpack_require__.getContainer = __webpack_require__.getContainer || function() { throw new Error("should have __webpack_require__.getContainer") };__webpack_require__.initContainer = __webpack_require__.initContainer || function() { throw new Error("should have __webpack_require__.initContainer") };